export default "__VITE_ASSET__c09fcf3b__"